/* tslint:disable */
/* eslint-disable */
/**
 * COTATO 프로젝트 API 명세서
 * api 명세서
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const CotatoGenerationMemberInfoPositionEnum = {
    None: 'NONE',
    Be: 'BE',
    Fe: 'FE',
    Design: 'DESIGN',
    Pm: 'PM'
};
/**
 * @export
 */
export const CotatoGenerationMemberInfoRoleEnum = {
    Member: 'MEMBER',
    LeaderTeam: 'LEADER_TEAM',
    OperationSupportTeam: 'OPERATION_SUPPORT_TEAM',
    EducationTeam: 'EDUCATION_TEAM',
    PlanningTeam: 'PLANNING_TEAM',
    MarketingTeam: 'MARKETING_TEAM'
};
/**
 * Check if a given object implements the CotatoGenerationMemberInfo interface.
 */
export function instanceOfCotatoGenerationMemberInfo(value) {
    return true;
}
export function CotatoGenerationMemberInfoFromJSON(json) {
    return CotatoGenerationMemberInfoFromJSONTyped(json, false);
}
export function CotatoGenerationMemberInfoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'generationMemberId': json['generationMemberId'] == null ? undefined : json['generationMemberId'],
        'name': json['name'] == null ? undefined : json['name'],
        'position': json['position'] == null ? undefined : json['position'],
        'generationNumber': json['generationNumber'] == null ? undefined : json['generationNumber'],
        'role': json['role'] == null ? undefined : json['role'],
    };
}
export function CotatoGenerationMemberInfoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'generationMemberId': value['generationMemberId'],
        'name': value['name'],
        'position': value['position'],
        'generationNumber': value['generationNumber'],
        'role': value['role'],
    };
}
